export default "__VITE_ASSET__BXN1dhMB__"